module.exports = __webpack_public_path__ + "static/media/11-image17.95ea0476.jpg";